<template>
    <!-- 付费结构模块 -->
    <div>
        <div class="data-panel">
            <div class="data-panel-header">
                <h2>{{conf.title}}</h2>
                <div class="extra">
                    <a-button @click="exportToExcel('ing_table', `${$service.PROJ_CODE}-${conf.title}-${version_type=='huodong'?'活动':'资料片'}`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                    <a-button @click="copy('ing_table')" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                    <a-radio-group v-model="version_type">
                        <a-radio-button value="huodong">活动</a-radio-button>
                        <a-radio-button value="banben">资料片</a-radio-button>
                    </a-radio-group>
                    <a-input placeholder="搜索活动名称" v-model="version_name" style="width:200px; margin:0 16px;" :allowClear="true"/>
                    <a-range-picker  class="date_range_picker" v-model="date_range"/>
                </div>
            </div>
            <div class="data-panel-content fixed-data-panel-content">
                <DataTable :fields="fields" :datas="filter_datas" ref="ing_table" class="fixed_version_table"/>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"

import {Tabs, Input} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Tabs)
Vue.use(Input)

import DataTable from '@/components/common/datatable.vue'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js'

export default {
    name: 'versionPanel',
    mixins: [datatableMixin],
    inject: ['today', 'yesterday', 'ranges'],
    components: {
        DataTable
    },
    props: {
        // 数据接口
        api: {
            type: String,
        },
        // 标题
        title: {
            type: String,
            default: "数据展示",
        },
        // 字段
        fields: {
            type: Array,
            default: ()=>{return []},
        },
        // 其他配置条件
        conf: {
            type: Object,
            default: ()=>{return {}},
        },
    },
    data() {
        return {
            version_type:'huodong',
            version_name: null,
            date_range: [],
            datas: [],
        }
    },
    watch: {
    },
    computed: {
        filter_datas() {
            let date_flag = false, start_dt = null, end_dt = null
            if(this.date_range && this.date_range.length==2) {
                date_flag = true
                start_dt = this.date_range[0].format('YYYY-MM-DD')
                end_dt = this.date_range[1].format('YYYY-MM-DD')
            }
            let filter_datas = []
            this.datas.forEach((row)=>{
                if(row.version_type != this.version_type)
                    return
                if(this.version_name && row.version_name.indexOf(this.version_name) < 0)
                    return
                if (date_flag && (end_dt < row.start_date || start_dt > row.end_date))
                    return
                filter_datas.push(row)
            })
            return filter_datas
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$service.query_fixed_module(this.api, {}).then((data)=>{
                this.datas = data
            })
        },
    }
}
</script>


<style lang="less">
.fixed_version_table .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
    padding: 12px 8px;
}
</style>